import React from 'react';
import {OverlayView} from '@react-google-maps/api';
import {MarkerWrapper, PointLabel, BusNumber} from './styles';
import {ReactComponent as FinishIcon} from 'assets/icons/finish_marker.svg';
import {useTranslation} from 'react-i18next';

const FinishMarker = ({ position, busNumber }) => {

  const {t} = useTranslation();

  return (
    <OverlayView 
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      position={position}>
      <MarkerWrapper>
        <FinishIcon />
        <PointLabel>{t('markers.end')}</PointLabel>
        <BusNumber>{busNumber}</BusNumber>
      </MarkerWrapper>
    </OverlayView>
  );
};

export default FinishMarker;